import { Box, Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from "react-i18next";
import LoaderComp from '../../../../../components/Loader/LoaderComp';
import { BackAndFowardInterface } from '../BackAndFowardComponent';
import { useState } from 'react';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { MenuStyles } from '../styles/MenuStyles';



export default function ActionsButton(props: BackAndFowardInterface) {

    const { t } = useTranslation();

    const backOperation = props.backOperation
    const forwardOperation = props.forwardOperation

    const truncatedBackOperation = backOperation?.trim().length! > 15 ? backOperation?.slice(0, 15) + "..." : backOperation
    const truncatedForwardOperation = forwardOperation?.trim().length! > 15 ? forwardOperation?.slice(0, 15) + "..." : forwardOperation

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            {props.actionForwadOrBackWait ? (
                <Box><LoaderComp /></Box>
            ) : (
                <>
                    <Button
                        id="action-validation-rule-button"
                        aria-controls={open ? 'action-validation-rule-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        sx={MenuStyles.button}
                        endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
                    >
                        {t("Action.message")}
                    </Button>
                    <Menu
                        id="action-validation-rule-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        sx={MenuStyles.menu}
                    >
                        <MenuItem onClick={() => { handleClose(); props.sendToBack() }} sx={MenuStyles.menuItem}>{truncatedBackOperation!}</MenuItem>
                        <MenuItem onClick={() => { handleClose(); props.sendToForwardItem() }} sx={MenuStyles.menuItem}>{truncatedForwardOperation!}</MenuItem>
                    </Menu>
                </>
            )}
        </>
    )
}